<template>
  <div class="d-flex flex-wrap align-items-start">
    <TextField
      v-model="email.email_address"
      :name="name"
      label-class="flex-1 mr-3 email-input"
      no-label
      :errorMessage="
        v$.email.email_address ? firstErrorMessage(v$.email.email_address) : ''
      "
      data-vv-as="Email"
      :data-vv-name="name"
      placeholder="Email"
      data-cy="email-address-input"
      @blur="handleBlur"
    />
    <div class="flex-1 d-flex align-items-center">
      <TextField
        v-model="email.label"
        label-class="flex-1"
        :name="`${email.id}-email-label`"
        :class="{
          'icon-margin-right-2x': !hideButtons && primary
        }"
        no-label
        data-vv-as="Label"
        placeholder="Label (Optional)"
      />
      <div
        v-if="!hideButtons && !primary"
        class="delete-icon ml-1 icon-margin-right"
        data-cy="delete-email"
        @click="$emit('delete-email', modelValue)"
      >
        <i class="fas fa-trash-alt"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import TextField from "@/components/TextField.vue";
import { createUniqueEmailValidator } from "@/mixins/validationRules.js";
import useVuelidate from "@vuelidate/core";
import { email, helpers, requiredIf } from "@vuelidate/validators";
export default {
  components: {
    TextField
  },
  props: {
    validateGlobalUniqueEmail: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Object,
      default: null
    },
    primary: {
      type: Boolean,
      default: false
    },
    hideButtons: {
      type: Boolean,
      default: false
    },
    uniqueAccountEmailValidator: {
      type: Function,
      default: null
    }
  },
  emits: ["update:modelValue", "delete-email"],
  validations() {
    const emailValidationRules = this?.getEmailValidationRules();
    const validationRules = {
      requiredIf: helpers.withMessage(
        "Email address is required",
        requiredIf(emailValidationRules.required)
      ),
      emailIf: emailValidationRules.email ? email : true,
      $lazy: true
    };

    if (emailValidationRules.uniqueEmail) {
      const initialEmail = this.modelValue?.email_address;
      validationRules.uniqueEmail = createUniqueEmailValidator(initialEmail);
    }
    if (
      emailValidationRules.uniqueAccountEmail &&
      this.uniqueAccountEmailValidator
    ) {
      validationRules.uniqueAccountEmail = this.uniqueAccountEmailValidator;
    }

    return {
      email: {
        email_address: validationRules
      }
    };
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      email: this.modelValue || {}
    };
  },
  computed: {
    name() {
      return this.primary ? "Email (Primary)" : `${this.email.id}`;
    }
  },
  watch: {
    email(newValue) {
      this.$emit("update:modelValue", newValue);
    },
    modelValue(newValue) {
      this.email = newValue;
    }
  },
  methods: {
    firstErrorMessage,
    handleBlur() {
      this.v$.email.email_address.$touch();
    },
    getEmailValidationRules() {
      if (this.primary) {
        return {
          required: true,
          email: true,
          uniqueEmail: this.validateGlobalUniqueEmail
            ? [this.modelValue]
            : false,
          uniqueAccountEmail: true
        };
      }
      return {
        required: true,
        email: true,
        uniqueAccountEmail: true
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.delete-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  min-width: 25px;
  i {
    font-size: 1rem;
  }
}
</style>
